// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const chespin: PokeData = {
  "id": 650,
  "name": "chespin",
  "height": 4,
  "weight": 90,
  "base_experience": 63,
  "types": [
    PokeType.GRASS
  ],
  "api_moves": [
    "vine-whip",
    "tackle",
    "body-slam",
    "take-down",
    "pin-missile",
    "bite",
    "growl",
    "leech-seed",
    "rollout",
    "pain-split",
    "bulk-up",
    "mud-shot",
    "seed-bomb",
    "wood-hammer"
  ],
  "moves": [
    "vine-whip",
    "tackle",
    "body-slam",
    "pin-missile",
    "bite",
    "growl",
    "bulk-up",
    "mud-shot",
    "wood-hammer",
    "bullet-seed",
    "flower-rush",
    "solar-beam",
    "branch-poke"
  ],
  "evolution_chain": {
    "id": 337,
    "item": null,
    "species": [
      {
        "name": "chespin",
        "order": 651,
        "types": [
          PokeType.GRASS
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "quilladin",
        "order": 652,
        "types": [
          PokeType.GRASS
        ],
        "evolves_from_species_id": 650,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 16,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      },
      {
        "name": "chesnaught",
        "order": 653,
        "types": [
          PokeType.GRASS,
          PokeType.FIGHTING
        ],
        "evolves_from_species_id": 651,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 36,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 55.5,
    "speed": 38,
    "ability_power": 61
  },
  "stat_changes": [],
  "catch_rate": 45,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
